import { AuthForm } from '@on3/ui-lib/components/Auth/Forms';
import { useRouter } from 'next/navigation';

import styles from './UserAuth.module.scss';

export interface UserAuthModalProps {
  defaultView?: 'login' | 'register';
  callback?: (props?: any) => void;
}

export const UserAuthModal = ({
  defaultView = 'login',
  callback: cb,
}: UserAuthModalProps) => {
  const router = useRouter();
  const callback = cb ? (p: any) => cb(p) : () => router.refresh();

  return (
    <div className={styles.block}>
      <AuthForm callback={callback} defaultView={defaultView} />
    </div>
  );
};
